<script lang="js">

export default {
    name: "EmailCard",
    props: {    enabled: {
      type: Boolean,
      default: true,
    }, },
    methods: {}
};
</script>

<template>
  <div class="card border-0 shadow-sm">
    <div class="card-body overflow-auto" style="max-height: 400px">
      <div class="row mb-4">
        <h6 class="fw-bold">Today</h6>

        <ul class="list-group list-group-flush">
          <li class="list-group-item" v-for="n in 3" :key="n">
            <p class="card-text placeholder-glow">
              <span class="placeholder col-7"></span>
              <span class="placeholder col-4"></span>
              <span class="placeholder col-4"></span>
              <span class="placeholder col-6"></span>
              <span class="placeholder col-8"></span>
            </p>
          </li>
        </ul>
      </div>

      <div class="row mb-4">
        <h6 class="fw-bold">Tomorrow</h6>

        <ul class="list-group list-group-flush">
          <li class="list-group-item" v-for="n in 2" :key="n">
            <p class="card-text placeholder-glow">
              <span class="placeholder col-7"></span>
              <span class="placeholder col-4"></span>
              <span class="placeholder col-4"></span>
              <span class="placeholder col-6"></span>
              <span class="placeholder col-8"></span>
            </p>
          </li>
        </ul>
      </div>
    </div>

    <div
      v-if="!enabled"
      class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 rounded-3"
      style="z-index: 10; cursor: not-allowed"
    >
      <h5 class="text-white fw-bold">Not activated yet</h5>
    </div>
  </div>
</template>
<style scoped></style>
